<template>
  <div
    class="md-6"
    style="position: absolute;top: 0;"
    :style="style_margin_position"
  >
    <div :id="_uid" class="myCanvas">
      <md-icon class="md-primary interaction-widget">zoom_in</md-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "interaction-widget",
  props: ["position", "flux"],
  mixins: [],
  components: {},
  data() {
    return {};
  },
  async mounted() {
    window.addEventListener("resize", () => {});
  },
  computed: {
    style_margin_position() {
      // on récupére les coordonnées (y,x) dans le xml. La margin top étant définit à partir du haut et le y étant définit
      // à partir du bas (point d'ordonnée), on inverse soustrait 100 - y , pour obtenir le margin top.
      var tab_position = this.position.split("|");
      return `margin-top:${100 - tab_position[0]}%;margin-left:${
        tab_position[1]
      }%`;
    }
  }
};
</script>
<style scoped>
.interaction-widget {
  text-shadow: 1px 1px 2px black;
  font-size: 32px !important;
}
</style>
